import { useState } from "react";
import type { CrudColumnDef } from "@/components/tables/crudColumnDef";
import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";
import {
  buildCreatePresetValues,
  buildEditPresetValues,
} from "@/components/tables/genericCrudTable.presetValues";

export type CrudModalMode = "insert" | "edit";

export interface UseCrudModalStateOptions {
  columns: CrudColumnDef[];
  customCreatePresetValues?: Record<string, any>;
  entityAdapter?: EntityAdapter;
}

export function useCrudModalState(options: UseCrudModalStateOptions) {
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [modalMode, setModalMode] = useState<CrudModalMode>("insert");
  const [modalPresetValues, setModalPresetValues] = useState<any>([]);

  const openCreateModal = () => {
    setModalMode("insert");
    setModalPresetValues(
      buildCreatePresetValues(options.customCreatePresetValues)
    );
    setModalOpen(true);
  };

  const openEditModal = (rowData: Record<string, any>) => {
    setModalPresetValues(
      buildEditPresetValues(
        rowData,
        options.columns,
        options.entityAdapter
      )
    );
    setModalMode("edit");
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalPresetValues([]);
    setModalOpen(false);
  };

  return {
    modalOpen,
    modalMode,
    modalPresetValues,
    openCreateModal,
    openEditModal,
    closeModal,
  };
}
